import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { PDPDownloadCard as Original } from 'components/molecules'
import { PDPDownloadCardSettings, PDPDownloadCardFloatingSettings } from './PDPDownloadCardSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

export const defaultProps = {
  label: '',
  url: '',
}

export const dynamicProps = []

export const PDPDownloadCard: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-pdp-download-card ${props.className}`}
      >
        <Original label={blockProps.label} url={blockProps.url} editMode={enabled} />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

PDPDownloadCard.craft = withCraft({
  name: 'PDPDownloadCard',
  defaultProps: defaultProps,
  settings: PDPDownloadCardSettings,
  floatingSettings: PDPDownloadCardFloatingSettings,
})
